import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.rate.gl.Filter.Selection,
  graphql.schema.GeneralLedgerFilterSelectionInput
>({
  attributeId: transformers.PASS_THROUGH,
  values: transformers.PASS_THROUGH,
})
